import { qportalApi } from './qportal-api';
import { convertModelToFormData } from './helpers';
const getWeeksByMonthYearAndAssignmentId = (request) => {
    return qportalApi.postForm(`timeSheet/getWeeklyTimeSheetsByMonthYearAndAssigmentId`, request);
};
const getTimeSheetsUsingStatus = (Status) => {
    return qportalApi.get(`timeSheet/GetTimeSheetsUsingStatus/${Status}`);
};
const uploadMonthlyTimeSheet = (document) => {
    const formData = convertModelToFormData(document);
    return qportalApi.postForm('timeSheet/uploadMonthlyTimeSheet', formData);
};
const getTimeSheetCountsByStatus = () => {
    return qportalApi.get('timeSheet/getTimeSheetCounts');
};
const getMonthSummary = (request) => qportalApi.get('timeSheet/MonthSummary', { params: request });
const downloadMonthPdf = (request) => qportalApi.get('timeSheet/DownloadMonthPdf', { params: request, responseType: 'blob' });
const TimeSheetApi = {
    getMonthSummary,
    downloadMonthPdf,
    getTimeSheetsUsingStatus,
    uploadMonthlyTimeSheet,
    getTimeSheetCountsByStatus,
    getWeeksByMonthYearAndAssignmentId
};
export default TimeSheetApi;
